export default {
  HANDLE_SUCCESS_GET_KEYS: 'handleSuccessGetKeys',
  GENERATE_KEY_IN_PROGRESS: 'generateKeyInProgress',
  TOGGLE_DEACTIVATE_KEY_MODAL: 'toggleDeactivateKeyModal',
  DEACTIVATE_KEY_IN_PROGRESS: 'deactivateKeyInProgress',
  HANDLES_SUCCESS_REVEAL_KEY: 'handleSuccessRevealKey',
};



// WEBPACK FOOTER //
// ./src/app/main/b2b/constants/action-types.js